import { useState, useEffect } from 'react';
import useHttp from '../hooks/useHttp';

// const testStoreCashUrl = 'https://storecash-pdp-slider.firebaseio.com/data.json'; // Test URL
const prodStoreCashUrl = 'https://prod-pdp-storecash-slider-default-rtdb.firebaseio.com/data.json'; // Prod URL

const FirebaseData = () => {

const [storeCashData, setStoreCashData] = useState(null);
const { firebaseerror, sendRequest, firebaseloading } = useHttp();
 
const rewardsData = data => {
setStoreCashData(data);
}

  useEffect(() => {
    sendRequest({ url: prodStoreCashUrl }, rewardsData);
  }, [sendRequest,prodStoreCashUrl]);


  const todayDate = new Date();
  const widgetControl = storeCashData?.widgetControl || {};
  const widgetRewards = storeCashData?.rewardsData || {};
  const widgetModals = storeCashData?.modalsData || {};

  
  const rewardNames = Object.keys(widgetRewards);


  const siteWideRewards = Object.values(widgetRewards).filter((item) => item.Is_Site_wide === true).filter(item => new Date(item.SiteWide_StartDate) < todayDate && 
  new Date(item.SiteWide_EndDate) > todayDate);
  const siteWideRewardsObject = siteWideRewards.reduce((acc, reward) => {
    acc[reward.Reward_Name] = reward;
    return acc;
  }, {});

//console.log('SiteWideRewardValue: ?? ','siteWideRewardsObject:',siteWideRewardsObject)
  const filteredWidgetControls = Object.values(widgetControl)
  .filter((item) => item !== null)
  .filter((wd) => {
    const startDate = new Date(wd.Start_date);
    const endDate = new Date(wd.End_date);
    return startDate < todayDate && endDate > todayDate;
  });
const headerText = filteredWidgetControls[0]?.Header_Text_html || '';
const subText = filteredWidgetControls[0]?.Sub_Text_html || '';



  return {widgetControl, widgetRewards, widgetModals,siteWideRewardsObject,headerText,subText,rewardNames,firebaseerror,firebaseloading};
};

export default FirebaseData;
